import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  err: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    console.error('UI error boundary caught:', err, info);
  }

  reset = (): void => this.setState({ err: null });

  render(): ReactNode {
    if (this.state.err) {
      return (
        <div className="flex h-full flex-col items-center justify-center p-8 text-center">
          <h1 className="text-xl font-semibold text-slate-900">Something went wrong.</h1>
          <p className="mt-2 max-w-md text-sm text-slate-600">
            The interface hit an unexpected error. Reload the page or try again.
          </p>
          <pre className="mt-4 w-full max-w-xl overflow-auto rounded bg-slate-100 p-3 text-left text-xs text-slate-700">
            {this.state.err.message}
          </pre>
          <button className="btn-secondary mt-6" onClick={() => location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
